import { render, staticRenderFns } from "./BookingDetails.vue?vue&type=template&id=9d274860&scoped=true"
import script from "./BookingDetails.vue?vue&type=script&lang=ts"
export * from "./BookingDetails.vue?vue&type=script&lang=ts"
import style0 from "./BookingDetails.vue?vue&type=style&index=0&id=9d274860&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d274860",
  null
  
)

export default component.exports